import React from 'react';

const CreatingAttestation = () => {
  return <>CreatingAttestation</>;
};
export default CreatingAttestation;
